import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import styles from "./DialogFooter.module.scss";
import { Button, ButtonProps } from "antd";

interface ActionFooterProps {
  submitProps?: ButtonProps;
  cancelProps?: ButtonProps;
}

function DialogFooter(props: ActionFooterProps) {
  const { submitProps, cancelProps } = props;

  return (
    <div className={`${styles.footDialog} flex flex-row gap-1`}>
      {cancelProps?.onClick && (
        <Button
          icon={<CloseCircleOutlined />}
          style={{
            fontSize: "13px",
            padding: "0.25rem 0.75rem",
            borderRadius: "4px",
          }}
          danger
          type="default"
          onClick={cancelProps?.onClick}
          {...cancelProps}
        >
          {cancelProps?.children || "Hủy"}
        </Button>
      )}

      {submitProps?.onClick && (
        <Button
          icon={<CheckCircleOutlined />}
          style={{
            fontSize: "13px",
            padding: "0.25rem 0.75rem",
            borderRadius: "4px",
          }}
          type="primary"
          onClick={submitProps?.onClick}
          {...submitProps}
        >
          {submitProps?.children || "Xác nhận"}
        </Button>
      )}
    </div>
  );
}

export default DialogFooter;
